import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './App.css';
import Flag from 'react-world-flags';

const languages = [
  { code: 'en', label: 'English', flag: 'gb' },
  { code: 'fr', label: 'Français', flag: 'fr' },
];


function LanguageSelector() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const selectLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
    setIsOpen(false);
  };

  const currentLang = languages.find((l) => l.code === i18n.language) || languages[0];

  return (
    <div className="lang-container">
      <div
        className="lang-selector-box"
        onClick={toggleDropdown}
        role="button"
        aria-expanded={isOpen}
      >
        <Flag code={currentLang.flag} style={{ width: 20, marginRight: 8 }} />
        <span>{currentLang.label}</span>
        <span className="lang-arrows" aria-hidden="true">
          <span className="arrow-up" />
          <span className="arrow-down" />
        </span>
      </div>
      {isOpen && (
        <div className="lang-dropdown-box">
          {languages.map((lang) => (
            <div
              key={lang.code}
              className={`lang-option ${lang.code === i18n.language ? 'active' : ''}`}
              onClick={() => selectLanguage(lang.code)}
            >
              <Flag code={lang.flag} style={{ width: 20, marginRight: 8 }} />
              {lang.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSelector;
